// Reseller identity comes from the build-time env var (VITE_APP_SUPER_TENANT),
// which Vite inlines as a literal — so this is safe to call anywhere, including
// module scope and route loaders, not only inside React components.
export const getReseller = () =>
  import.meta.env.VITE_APP_SUPER_TENANT?.toLowerCase();
